/**
 * Shared tooltip messages for CodeMirror error highlighting
 * This centralizes error message content to avoid duplication
 */

export const TOOLTIP_MESSAGES = {
    AMBIGUOUS_TERM_ERROR: '<strong>Error:</strong> Ambiguous term, 2 scenarios:\n\n<strong>Scenario 1:</strong> This term is meant to be a new term that does not yet exist. Further specify this term to distinguish it from existing terms.\n\n<strong>Scenario 2:</strong> This term is meant to reference an existing term. Change the preceding article to a definite article ("the" or "said").'
};